export const getSlimIdentity = /* GraphQL */ `
  query GetIdentity($id: ID!) {
    getPlatformUser(id: $id) {
      id
      name
      username
      email
      avatar_image
      tou_accepted
      localization

      roles {
        role_id
        name
      }
      account {
        config {
          custom_activities
        }
        id
        name
        services
      }
    }
  }
`;
export const getIdentity = /* GraphQL */ `
  query GetIdentity($id: ID!) {
    getPlatformUser(id: $id) {
      id
      name
      username
      email
      avatar_image
      tou_accepted
      localization
      # get_perf_email
      notification_config {
        perf_email
        weather_alerts
        email_notification
      }
      account {
        config {
          custom_activities
          customization
        }
        id
        name
        services
        tier
        companies {
          id
          name
          is_howden_client
          num_completed_activities
          risk_score
          # profile_completion
          status
          surveys_count
          total_recs_count
          activities_counters {
            total
          }
          activity_by_category {
            completed
            scheduled
            master_risk_category {
              id
            }
          }
          # last_risk_profile {
          #   id
          #   profile_completion
          #   risk_categories {
          #     id
          #     name
          #     description
          #     sum_controls
          #     sum_parameters
          #     risk_parameters {
          #       id
          #       name
          #       risk_controls {
          #         id
          #         name
          #         state {
          #           id
          #           state
          #           updated
          #         }
          #         possible_states {
          #           state
          #           id
          #         }
          #       }
          #     }
          #   }
          # }
          policy {
            inception_date
            expiration_date
            current_discount
            documents {
              file_name
              file_type
              id
              media_type
              title
            }
          }
          index_rank
          monthly_scores {
            run_id
            predicted_score
            location
            created
          }

          locations {
            id
            name
          }
          #   risk_score
          #   num_completed_activities
          #   num_expected_activities
          #   activity_by_category {
          #     completed
          #     scheduled
          #     master_risk_category {
          #       id
          #     }
          #   }
          #   last_risk_profile {
          #     id
          #     profile_completion
          #     risk_categories {
          #       id
          #       name
          #       description
          #       sum_controls
          #       sum_parameters
          #       risk_parameters {
          #         id
          #         name
          #         risk_controls {
          #           id
          #           name
          #           state {
          #             id
          #             state
          #             updated
          #           }
          #           possible_states {
          #             state
          #             id
          #           }
          #         }
          #       }
          #     }
          #   }
          #   index_rank
          #   monthly_scores {
          #     run_id
          #     predicted_score
          #     location
          #     created
          #   }
          # }
        }
      }
      roles {
        role_id
        name
      }
      locations {
        id
        name
        risk_score
        num_completed_activities
        num_expected_activities
        activity_by_category {
          completed
          scheduled
          master_risk_category {
            id
          }
        }
        last_risk_profile {
          id
          profile_completion
          risk_categories {
            id
            name
            description
            sum_controls
            sum_parameters
            risk_parameters {
              id
              name
              risk_controls {
                id
                name
                state {
                  id
                  state
                  updated
                }
                possible_states {
                  state
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;
export const checkUserActivity = /* GraphQL */ `
  query CheckUserActivity($id: ID!) {
    getPlatformUser(id: $id) {
      last_active
    }
  }
`;
export const getCognitoDataUser = /* GraphQL */ `
  query GetCognitoDataUser($username: String!) {
    getCognitoDataUser(username: $username) {
      user_pool_id
      identity_pool_id
      cognito_client_id
    }
  }
`;
export const getCumulAuthToken = /* GraphQL */ `
  query GetCumulAuthToken($dashboardId: String!, $companyId: String, $userId: String, $locationId: String) {
    getCumulAuthToken(dashboardId: $dashboardId, companyId: $companyId, userId: $userId, locationId: $locationId) {
      id
      token
    }
  }
`;
export const getPlatformUser = /* GraphQL */ `
  query GetPlatformUser($id: ID!) {
    getPlatformUser(id: $id) {
      id
      # get_perf_email
      notification_config {
        perf_email
        weather_alerts
        email_notification
      }
      account {
        id
        name
        services
        companies {
          id
          name
        }
      }
      localization
      created
      updated
      is_active
      name
      first_name
      second_name
      username
      email
      avatar_image
      phone_number
      user_pool_id
      cognito_status
      last_login
      roles {
        id
        name
        role_id
      }
      locations {
        id
        name
        is_weather_alert
      }
      use_2fa
    }
  }
`;
export const getPlatformUserWithAccountCompanies = /* GraphQL */ `
  query GetPlatformUser($id: ID!) {
    getPlatformUser(id: $id) {
      id
      # get_perf_email
      notification_config {
        perf_email
        weather_alerts
        email_notification
      }
      account {
        id
        name
        services
        companies {
          id
          name
        }
      }
      created
      updated
      is_active
      name
      first_name
      second_name
      username
      email
      avatar_image
      phone_number
      user_pool_id
      cognito_status
      last_login
      roles {
        id
        name
        role_id
      }
      locations {
        id
        name
        is_weather_alert
      }
    }
  }
`;
export const listRoles = /* GraphQL */ `
  query ListRoles($q: StandardQuery) {
    listRoles(q: $q) {
      list {
        id
        account {
          id
          name
          created
          updated
          deleted
          is_active
          services
          user_pool_id
          identity_pool_id
          cognito_client_id
        }
        name
        role_arn
        role_id
        is_system_role
        created
        updated
        deleted
      }
      size
      count
      offset
    }
  }
`;
export const listServiceRoles = /* GraphQL */ `
  query ListServiceRoles($q: StandardQueryWithoutAccount) {
    listServiceRoles(q: $q) {
      list {
        id
        name
        role_id
        service
      }
      size
      count
      offset
    }
  }
`;
export const listPlatformUsers = /* GraphQL */ `
  query ListPlatformUsers($q: StandardQuery) {
    listPlatformUsers(q: $q) {
      list {
        id
        account {
          id
          name
          created
          updated
          deleted
          is_active
          services
          user_pool_id
          identity_pool_id
          cognito_client_id
        }
        created
        updated
        deleted
        is_active
        name
        username
        email
        avatar_image
        sub
        phone_number
        user_pool_id
        cognito_status
        last_login
        roles {
          id
          name
          role_arn
          role_id
          is_system_role
          created
          updated
          deleted
        }
        locations {
          id
          name
        }
        teams {
          name
        }
      }
      size
      count
      offset
    }
  }
`;
export const listPlatformUsersForModalSelection = /* GraphQL */ `
  query ListPlatformUsers($q: StandardQuery) {
    listPlatformUsers(q: $q) {
      list {
        id
        name
        username
        email
        avatar_image
        cognito_status
        last_login
        is_active
        roles {
          id
          name
        }
        locations {
          id
          name
        }
      }
      size
      count
      offset
    }
  }
`;
export const listUpcomingEvents = /* GraphQL */ `
  query ListUpcomingEvents($q: UpcomingEventQuery) {
    listUpcomingEvents(q: $q) {
      list {
        id
        name
        location_id
        location_name
        event_type
        date
      }
      size
      count
      offset
    }
  }
`;
export const listMasterActivityTemplates = /* GraphQL */ `
  query ListMasterActivityTemplates($q: StandardQueryWithCompanyOptional) {
    listMasterActivityTemplates(q: $q) {
      list {
        activity_source
        is_policy_condition
        paused_scheduling
        id
        name
        updated
        rec_frequency_interval
        rec_frequency_unit
        assignment_type
        description
        master_risk_management_programs {
          id
          title
        }
        checklist
        master_risk_category {
          name
        }
        mappings {
          master_risk_control {
            id
            name
          }
        }
        owner_account {
          id
          name
        }
      }
      count
      offset
      size
    }
  }
`;
export const listMasterActivityTemplatesForModalSelection = /* GraphQL */ `
  query ListMasterActivityTemplates($q: StandardQueryWithCompanyOptional) {
    listMasterActivityTemplates(q: $q) {
      list {
        id
        name
        updated
        rec_frequency_interval
        rec_frequency_unit
        assignment_type
        description
        checklist
        manual_scheduling
        master_risk_category {
          name
        }
      }
      count
      offset
      size
    }
  }
`;
export const getRiskManagementProgram = /* GraphQL */ `
  query GetRiskManagementProgram($id: ID!) {
    getRiskManagementProgram(id: $id) {
      id
      title
      updated
      created
      activities_count
      status
      sections {
        id
        title
        description
        activities {
          assignment_type
          rec_frequency_interval
          rec_frequency_unit
          schedule_after_interval
          schedule_after_unit
          trigger_type
          trigger_id
          master_activity_template {
            id
            name
            description
            master_risk_category {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export const listAssociatedMasterRMPs = /* GraphQL */ `
  query ListAssociatedMasterRMPs($q: StandardQueryWithCompany) {
    listAssociatedMasterRMPs(q: $q) {
      list {
        masterrmp {
          id
          title
          activities_count
          created
          updated
        }
        status
        created
        updated
      }
      count
      offset
      size
    }
  }
`;
export const listAssociatedMasterRMPsAndSection = /* GraphQL */ `
  query ListAssociatedMasterRMPs($q: StandardQueryWithCompany) {
    listAssociatedMasterRMPs(q: $q) {
      list {
        masterrmp {
          id
          title
          activities_count
          sections {
            title
            description
            activities {
              master_activity_template {
                id
                name
                description
                master_risk_category {
                  id
                  name
                }
              }
              assignment_type
              rec_frequency_interval
              rec_frequency_unit
            }
          }
          created
          updated
        }
        status
        created
        updated
      }
      count
      offset
      size
    }
  }
`;
export const listAssociatedMasterActivityTemplates = /* GraphQL */ `
  query ListAssociatedMasterActivityTemplates($q: StandardQueryWithCompany) {
    listAssociatedMasterActivityTemplates(q: $q) {
      list {
        is_policy_condition
        paused_scheduling
        id
        name
        updated
        rec_frequency_interval
        rec_frequency_unit
        assignment_type
        description
        master_risk_management_programs {
          id
          title
        }
        checklist
        master_risk_category {
          name
        }
        mappings {
          master_risk_control {
            id
            name
          }
        }
      }
      count
      offset
      size
    }
  }
`;
export const listScheduledMasterActivityTemplates = /* GraphQL */ `
  query ListScheduledMasterActivityTemplates($q: StandardQueryWithCompany) {
    listScheduledMasterActivityTemplates(q: $q) {
      list {
        requires_approval
        next_available_after
        next_timezone
        paused_scheduling
        is_policy_condition
        activity_source
        id
        name
        locations
        updated
        rec_frequency_interval
        rec_frequency_unit
        assignment_type
        description
        num_completed_activities
        num_expected_activities
        master_risk_management_programs {
          id
          title
        }
        checklist
        master_risk_category {
          name
        }
        mappings {
          master_risk_control {
            id
            name
          }
        }
      }
      count
      offset
      size

      available
      done
      done_month
      missed
      missed_month
      overdue
      total
      total_month
      pending_approval
    }
  }
`;
export const listRiskManagementPrograms = /* GraphQL */ `
  query ListRiskManagementPrograms($q: StandardQueryWithCompanyOptional) {
    listRiskManagementPrograms(q: $q) {
      list {
        id
        status
        title
        activities_count
        master_risk_management_program {
          id
        }
        sections {
          title
          description
          activities {
            id
            name
            description
            master_activity_template {
              id
              master_risk_category {
                id
                name
              }
            }
            rec_frequency_interval
            rec_frequency_unit
            master_risk_category {
              id
              name
            }
          }
        }
        created
        created_by {
          name
          id
        }
        updated
      }
      count
      offset
      size
    }
  }
`;
export const listRiskManagementProgramsForDropdown = /* GraphQL */ `
  query ListRiskManagementPrograms($q: StandardQueryWithCompanyOptional) {
    listRiskManagementPrograms(q: $q) {
      list {
        id
        title
      }
      count
      offset
      size
    }
  }
`;
export const listMasterRiskManagementProgramsForDropdown = /* GraphQL */ `
  query ListMasterRiskManagementPrograms($q: StandardQuery) {
    listMasterRiskManagementPrograms(q: $q) {
      list {
        id
        title
      }
      count
      offset
      size
    }
  }
`;
export const listSectors = /* GraphQL */ `
  query ListSectors($q: StandardQuery) {
    listSectors(q: $q) {
      list {
        id
        name
        code
        children {
          id
          name
          children {
            id
            name
          }
        }
        parent {
          id
          name
        }
      }
      size
      count
      offset
    }
  }
`;
export const getCompanyProfile = /* GraphQL */ `
  query GetCompanyProfile($id: ID!) {
    getCompanyProfile(id: $id) {
      id
      name
      account_number
      sic
      status
      tin
      sector {
        id
        name
      }
      insurance_product {
        id
        name
        latest_version {
          version
          id
        }
        accounts {
          id
          name
        }
      }
      address {
        id
        address_line_1
        address_line_2
        city
        state_province
        country
        country_code
        postal_code
        geo
      }
      assigned_mrmp {
        id
        title
        type
        sections {
          id
          title
          description
          activities {
            master_activity_template {
              id
              name
              description
              activity_type
              assignment_type
            }
            trigger_type
            trigger_id
            assignment_type
            rec_frequency_interval
            rec_frequency_unit
            schedule_after_interval
            schedule_after_unit
          }
        }
      }
      logo_image
      sites_count
      surveys_count
      open_recs_count
      total_recs_count
      documents_count
      contacts_count
      risk_score
      policy_renewal_date
      summary
      tiv
      sic
      last_survey_date
      next_survey_date
      activity_by_category {
        completed
        scheduled
        master_risk_category {
          id
        }
      }
      # activity_by_location {
      #   master_activity_template
      #   master_activity_template_name
      #   location
      #   location_name
      # }
      activities_next_available_date {
        master_activity_template
        next_available
        timezone
      }
      activities_completion_data {
        master_activity_template
        num_completed_activities
        num_expected_activities
      }
      policy {
        id
        policy_ref
        expiration_date
        documents {
          file_name
          file_type
          id
          media_type
          title
        }
      }
      risk_model {
        id
      }
      # last_risk_profile {
      #   id
      #   profile_completion
      #   risk_categories {
      #     id
      #     name
      #     description
      #     sum_controls
      #     sum_parameters
      #     risk_parameters {
      #       id
      #       name
      #       risk_controls {
      #         id
      #         name
      #         state {
      #           id
      #           state
      #           updated
      #         }
      #         possible_states {
      #           state
      #           id
      #         }
      #       }
      #     }
      #   }
      # }
      # profile_completion
    }
  }
`;
export const getInsuredCompanyProfile = /* GraphQL */ `
  query GetInsuredCompanyProfile($id: ID!) {
    getInsuredCompanyProfile(id: $id) {
      id
      name
      sic
      status
      tin
      sector {
        id
        name
      }
      insurance_product {
        id
        name
        latest_version {
          version
          id
        }
        accounts {
          id
          name
        }
      }
      address {
        id
        address_line_1
        address_line_2
        city
        state_province
        country
        country_code
        postal_code
        geo
      }
      assigned_mrmp {
        id
        title
        type
        sections {
          id
          title
          description
          activities {
            master_activity_template {
              id
              name
              description
              activity_type
              assignment_type
            }
            trigger_type
            trigger_id
            assignment_type
            rec_frequency_interval
            rec_frequency_unit
            schedule_after_interval
            schedule_after_unit
          }
        }
      }
      logo_image
      sites_count
      surveys_count
      open_recs_count
      total_recs_count
      documents_count
      contacts_count
      risk_score
      policy_renewal_date
      summary
      tiv
      sic
      last_survey_date
      next_survey_date
      activity_by_category {
        completed
        scheduled
        master_risk_category {
          id
        }
      }
      # activity_by_location {
      #   master_activity_template
      #   master_activity_template_name
      #   location
      #   location_name
      # }
      activities_next_available_date {
        master_activity_template
        next_available
        timezone
      }
      activities_completion_data {
        master_activity_template
        num_completed_activities
        num_expected_activities
      }
      policy {
        id
        policy_ref
        expiration_date
        documents {
          file_name
          file_type
          id
          media_type
          title
        }
      }
      risk_model {
        id
      }
      # last_risk_profile {
      #   id
      #   profile_completion
      #   risk_categories {
      #     id
      #     name
      #     description
      #     sum_controls
      #     sum_parameters
      #     risk_parameters {
      #       id
      #       name
      #       risk_controls {
      #         id
      #         name
      #         state {
      #           id
      #           state
      #           updated
      #         }
      #         possible_states {
      #           state
      #           id
      #         }
      #       }
      #     }
      #   }
      # }
      # profile_completion
    }
  }
`;
export const getCompletionPercentage = /* GraphQL */ `
  query GetCompletionPercentage($master_activity_template: ID, $company_profile: ID) {
    getCompletionPercentage(master_activity_template: $master_activity_template, company_profile: $company_profile) {
      master_activity_template
      company_profile
      num_completed_activities
      num_expected_activities
    }
  }
`;
export const listLocations = /* GraphQL */ `
  query ListLocations($q: StandardQueryWithCompany) {
    listLocations(q: $q) {
      list {
        id
        calibration_date
        company_profile {
          id
          name
        }
        address {
          id
          address_line_1
          address_line_2
          city
          state_province
          country
          country_code
          postal_code
          geo
        }
        name
        image
        geo
        location_type
        last_survey_date
        next_survey_date
        open_recs_count
        total_recs_count
        risk_score
        num_completed_activities
        num_expected_activities
        surveys_count
        air
        iso
        tiv
      }
      size
      count
      offset
    }
  }
`;
export const getCompanyProfilePredictions = /* GraphQL */ `
  query GetCompanyProfile($id: ID!) {
    getCompanyProfile(id: $id) {
      id
      risk_score
      index_rank
      current_policy_monthly_scores {
        run_id
        predicted_score
        location
        created
      }
    }
  }
`;
export const listPolicys = /* GraphQL */ `
  query ListPolicys($q: StandardQuery) {
    listPolicys(q: $q) {
      list {
        id
        status
        current_discount
        inception_date
        expiration_date
        # policy_type
        product {
          id
          name
          latest_version {
            version
            id
          }
        }
        policy_ref
        # retail_broker
        # carriers
        documents {
          file_name
          file_type
          id
          title
          preview_image
          media_type
          latest_file_ref
          document_type
        }
      }
      size
      count
      offset
    }
  }
`;
export const getPolicy = /* GraphQL */ `
  query GetPolicy($id: ID!) {
    getPolicy(id: $id) {
      # carriers
      company_profile {
        id
        name
      }
      created
      current_discount
      deleted
      expiration_date
      id
      inception_date
      labels
      policy_ref
      # policy_type
      # retail_broker
      tsi
      updated
      product {
        id
        name
      }
      documents {
        file_name
        file_type
        id
        title
        preview_image
        media_type
        latest_file_ref
        document_type
      }
    }
  }
`;
export const listPlatformUsersTable = /* GraphQL */ `
  query ListPlatformUsers($q: StandardQuery) {
    listPlatformUsers(q: $q) {
      list {
        id
        last_login
        created
        updated
        is_active
        name
        username
        email
        avatar_image
        phone_number
        roles {
          id
          name
        }
      }
      size
      count
      offset
    }
  }
`;
export const listPlatformUsersForDropdown = /* GraphQL */ `
  query ListPlatformUsers($q: StandardQuery) {
    listPlatformUsers(q: $q) {
      list {
        id
        name
      }
      size
      count
      offset
    }
  }
`;
export const listAccountsForDropdown = /* GraphQL */ `
  query ListAccounts($q: StandardQuery) {
    listAccounts(q: $q) {
      list {
        id
        name
        services
      }
      size
      count
      offset
    }
  }
`;
export const listCompanysForDropdown = /* GraphQL */ `
  query ListCompanyProfiles($q: StandardQuery) {
    listCompanyProfiles(q: $q) {
      list {
        id
        name
      }
      size
      count
      offset
    }
  }
`;
export const listLocationsForDropdown = /* GraphQL */ `
  query ListLocations($q: StandardQueryWithCompany) {
    listLocations(q: $q) {
      list {
        id
        name
      }
      size
      count
      offset
    }
  }
`;
export const listLocationsWithManagersForDropdown = /* GraphQL */ `
  query ListLocations($q: StandardQueryWithCompany) {
    listLocations(q: $q) {
      list {
        id
        name
        is_favourite
        is_weather_alert
        manager {
          id
          name
          locations {
            id
            name
          }
        }
      }
      size
      count
      offset
    }
  }
`;
export const listSurveysForDropdown = /* GraphQL */ `
  query ListSurveys($q: StandardQuery) {
    listSurveys(q: $q) {
      list {
        id
        name
        agency {
          id
        }
        classification {
          id
          name
        }
      }
      size
      count
      offset
    }
  }
`;
export const listManagedSites = /* GraphQL */ `
  query ListManagedSites($q: ManagedSitesQuery) {
    listManagedSites(q: $q) {
      list {
        id
        name
        open_recs_count
        total_recs_count
        risk_score
        is_favourite
      }
      size
      count
      offset
    }
  }
`;
export const listAgencys = /* GraphQL */ `
  query ListAgencys($q: StandardQuery) {
    listAgencys(q: $q) {
      list {
        id
        name
        # children {
        #   id
        #   name
        #   children {
        #     id
        #     name
        #   }
        # }
      }
      size
      count
      offset
    }
  }
`;
export const getLocation = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      tiv
      ranking {
        rank
      }
      engineer_score {
        current_score
        potential_score
        current_classification
        potential_classification
      }
      calibration_date
      status
      company_profile {
        id
        name
      }
      address {
        id
        address_line_1
        address_line_2
        city
        state_province
        country
        country_code
        postal_code
        geo
      }
      name
      description
      image
      geo
      location_type
      air
      iso
      sic
      surveys_count
      total_recs_count
      documents_count
      contacts_count
      geo
      last_survey_date
      next_survey_date
      risk_score
      activity_by_category {
        completed
        scheduled
        master_risk_category {
          id
        }
      }
      last_risk_profile {
        id
        profile_completion
        risk_categories {
          id
          name
          description
          sum_controls
          sum_parameters
          risk_parameters {
            id
            name
            risk_controls {
              id
              name
              type
              state {
                id
                state
                updated
              }
              possible_states {
                state
                id
              }
            }
          }
        }
      }
      monthly_scores {
        run_id
        predicted_score
        location
        created
      }
      index_rank
      manager {
        id
        name
        avatar_image
        account {
          id
        }
        last_login
        is_active
      }
    }
  }
`;
export const listSurveys = /* GraphQL */ `
  query ListSurveys($q: StandardQuery) {
    listSurveys(q: $q) {
      list {
        id
        name
        overall_classification {
          current_score
          potential_score
          current_classification
          potential_classification
        }
        company_profile {
          name
        }
        location {
          id
          name
          address {
            id
            city
            state_province
            country_code
          }
        }
        survey_status
        visit_date
        report_issued_date
        managed_by {
          id
          name
        }
        survey_type
        updated
      }
      size
      count
      offset
    }
  }
`;
export const listRecentlyUpdatedSurveys = /* GraphQL */ `
  query ListSurveys($q: StandardQuery) {
    listSurveys(q: $q) {
      list {
        id
        name
        company_profile {
          name
        }
        location {
          id
          name
        }
        survey_status
        visit_date
      }
      size
      count
      offset
    }
  }
`;
export const getSurvey = /* GraphQL */ `
  query GetSurvey($id: ID!) {
    getSurvey(id: $id) {
      id
      name
      risk_classification
      overall_classification {
        current_score
        potential_score
        current_classification
        potential_classification
      }
      location {
        id
        name
        tiv
        address {
          id
          address_line_1
          address_line_2
          city
          state_province
          country
          country_code
          postal_code
          geo
        }
        manager {
          id
          name
        }
        recommendations {
          id
        }
      }
      company_profile {
        id
        name
      }
      classification {
        id
        name
      }
      agency {
        id
        name
      }
      recommendations {
        id
      }
      survey_status
      visit_date
      report_issued_date
      managed_by {
        id
        name
      }
      survey_type
      cope {
        id
      }
      lossEstimate {
        id
        total_pd_bi
      }
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments($q: StandardQueryWithCompany) {
    listDocuments(q: $q) {
      list {
        id
        title
        file_type
        file_name
        preview_image
        document_type
        company_profile {
          id
          name
        }
        location {
          id
          name
          address {
            city
            state_province
            country_code
          }
        }
        survey {
          id
          name
        }
        agency {
          id
          name
        }
        created_by {
          id
          name
        }
        updated
        created
      }
      size
      count
      offset
    }
  }
`;
export const listCompanyProfiles = /* GraphQL */ `
  query ListCompanyProfiles($q: StandardQuery) {
    listCompanyProfiles(q: $q) {
      list {
        id
        name
        sic
        status
        accounts
        policy_submitted
        sector {
          id
          name
        }
        address {
          id
          city
          state_province
          country_code
          country
        }
        logo_image
        sites_count
        risk_score
        first_risk_score
        policy_renewal_date
        last_survey_date
        tiv
        num_completed_activities
        num_expected_activities
        insurance_product {
          name
          num_completed_activities
          num_expected_activities
          avg_risk_score
          avg_risk_score_change
        }
        current_policy_monthly_scores {
          run_id
          predicted_score
          location
          created
          company_profile
        }
        insurer {
          id
          name
        }
        my_sme_spec_account {
          id
          name
        }
        policy {
          documents {
            file_name
            file_type
            id
            media_type
            title
          }
        }
        created
        updated
      }
      size
      count
      offset
    }
  }
`;
export const listInsuredCompanyProfiles = /* GraphQL */ `
  query ListInsuredCompanyProfiles($q: StandardQuery) {
    listInsuredCompanyProfiles(q: $q) {
      active
      lapsed
      list {
        id
        name
        sic
        accounts
        policy_submitted
        policy_compliance
        sector {
          id
          name
        }
        address {
          id
          city
          state_province
          country_code
          country
        }
        logo_image
        sites_count
        risk_score
        first_risk_score
        policy_renewal_date
        last_survey_date
        tiv
        num_completed_activities
        num_expected_activities
        insurance_product {
          name
          num_completed_activities
          num_expected_activities
          avg_risk_score
          avg_risk_score_change
        }
        current_policy_monthly_scores {
          run_id
          predicted_score
          location
          created
          company_profile
        }
        insurer {
          id
          name
        }
        my_sme_spec_account {
          id
          name
        }
        policy {
          status
          documents {
            file_name
            file_type
            id
            media_type
            title
          }
        }
        created
        updated
      }
      size
      count
      offset
    }
  }
`;
export const listCompanyProfilesForDropdown = /* GraphQL */ `
  query ListCompanyProfiles($q: StandardQuery) {
    listCompanyProfiles(q: $q) {
      list {
        id
        name
      }
      size
      count
      offset
    }
  }
`;
export const listRecentlyVisitedCompanys = /* GraphQL */ `
  query ListCompanyProfiles($q: StandardQuery) {
    listCompanyProfiles(q: $q) {
      list {
        id
        name
        logo_image
        status
        address {
          id
          city
          state_province
          country_code
        }
        my_sme_spec_account {
          id
          name
          services
        }
        risk_score
        last_survey_date
        engineer_score {
          current_score
          potential_score
          current_classification
          potential_classification
        }
      }
      size
      count
      offset
    }
  }
`;
export const listTeams = /* GraphQL */ `
  query ListTeams($q: StandardQueryWithoutAccount) {
    listTeams(q: $q) {
      list {
        id
        account
        name
        description
        logo_image
        clients {
          id
          name
        }
        users {
          id
          name
        }
        created
        updated
        deleted
      }
      count
      offset
      size
    }
  }
`;
export const listRecommendations = /* GraphQL */ `
  query ListRecommendations($q: StandardQueryWithCompanyOptional) {
    listRecommendations(q: $q) {
      list {
        id
        rec_id
        risk_category
        name
        classification {
          id
          name
        }
        rec_category
        location {
          id
          name
          address {
            id
            city
            state_province
            country_code
          }
        }
        survey {
          classification {
            id
            name
          }
        }
        estimated_loss
        status
        due_date
      }
      size
      count
      offset
    }
  }
`;
export const getRecommendation = /* GraphQL */ `
  query GetRecommendation($id: ID!) {
    getRecommendation(id: $id) {
      id
      company_profile {
        id
        name
      }
      location {
        id
        name
        address {
          geo
        }
      }
      survey {
        id
        name
        agency {
          id
          name
        }
        company_profile {
          id
          name
        }
        classification {
          id
          name
        }
      }
      classification {
        id
        name
        children {
          id
          name
          children {
            id
            name
          }
        }
      }
      sub_classification {
        id
        name
      }
      sub_sub_classification {
        id
        name
      }
      contact {
        id
        name
        email
        phone
      }
      rec_id
      name
      date_issued
      due_date
      status
      location_site
      geo
      risk_category
      client_classification
      rec_category
      observations
      recommendations
      estimated_loss
      estimated_loss_range_upper
      estimated_loss_range_lower
      after_completion_loss
      after_completion_loss_upper
      after_completion_loss_lower
      updated
    }
  }
`;
export const getAccount = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      name
      created
      updated
      deleted
      is_active
      services
      user_pool_id
      identity_pool_id
      cognito_client_id
      account_ref
      roles {
        id
        name
        role_id
      }
      companies {
        id
        name
      }
      config {
        custom_activities
      }
    }
  }
`;
export const getAccountWithCompanies = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      name
      created
      updated
      deleted
      is_active
      services
      user_pool_id
      identity_pool_id
      cognito_client_id
      roles {
        id
        name
        role_id
      }
      companies {
        id
        name
      }
    }
  }
`;
export const listClassifications = /* GraphQL */ `
  query ListClassifications($q: StandardQuery) {
    listClassifications(q: $q) {
      list {
        id
        name
        children {
          id
          name
          children {
            id
            name
            children {
              id
              name
            }
          }
        }
      }
      size
      count
      offset
    }
  }
`;
export const getSector = /* GraphQL */ `
  query GetSector($id: ID!) {
    getSector(id: $id) {
      id
      name
      code
      parent {
        name
        id
      }
      children {
        id
        name
      }
      default_control_states {
        control {
          id
          name
          states {
            id
            state
          }
        }
        state {
          id
          state
        }
      }
    }
  }
`;
export const getDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      policy
      title
      description
      media_type
      document_type
      file_type
      file_name
      preview_image
      created_by {
        id
        name
        avatar_image
      }
      created
      company_profile {
        id
        name
      }
      location {
        id
        name
        address {
          geo
        }
      }
      survey {
        id
        name
      }
      agency {
        id
        name
      }
    }
  }
`;
export const getCope = /* GraphQL */ `
  query GetCope($id: ID!) {
    getCope(id: $id) {
      id
      survey {
        id
        name
      }
      company_profile {
        id
        name
      }
      location {
        id
        name
      }
      iso_class
      fire_resistant_pc
      non_combustible_pc
      combustible_pc
      sic_code
      working_hours_per_day
      working_days_per_week
      number_of_employees
      manufacturing_pc
      warehousing_pc
      office_pc
      retail_pc
      other_pc
      special_hazards
      occupancy_hazard_class
      common_hazards
      storage_type
      max_storage_height
      commodity_class
      surveillance
      as_valve_inspections
      fire_pump_inspections
      infrared_scans
      alarm_testing
      fire_door_maintenance_test
      extinguisher_maintenance_inspection
      smoking_controls
      housekeeping
      general_maintenance
      contractor_supervision
      hot_work_monitoring
      impairment_handling
      management_of_change
      emergency_response_bcp
      eo_training
      area_as_with_adeqate_design_pc
      area_as_with_deficient_design_pc
      area_ns_needing_as_pc
      area_ns_not_needing_as
      public_ws
      private_ws
      ws_duration
      as_evaluation
      ws_evaluation
      special_hazards_protection_evaluation
      hydrants
      special_protection
      extinguishers
      hose
      alarms
      as_valves_locked_q
      as_waterflow_alarm_q
      fire_pump_monitored_q
      smoke_or_heat_detectors_q
      intrusion_detection_q
      as_valve_tamper_alarms_q
      other_alarms_q
      eo_type
      public_fd_type
      iso_community_rating
      nearest_fd_station
      ir_inspection_organisation
      external_fire_exposure
      external_fire_exposure_protection
      construction_narrative
      occupancy_narrative
      exposure_narrative
      protection_narrative
      as_valve_inspections_narrative
      fire_pump_inspections_narrative
      alarm_testing_narrative
      fire_door_maintenance_test_narrative
      extinguisher_maintenance_inspection_narrative

      housekeeping_narrative
      surveillance_narrative
      smoking_controls_narrative
      general_maintenance_narrative
      contractor_supervision_narrative
      hot_work_monitoring_narrative
      impairment_handling_narrative
      emergency_response_bcp_narrative
      management_of_change_narrative

      ws_evaluation_narrative
      ws_duration_narrative
      public_ws_narrative
      private_ws_narrative

      special_hazards_protection_evaluation_narrative
      special_protection_narrative
      hose_narrative
      hydrants_narrative
      extinguishers_narrative

      sprinklers_narrative
      fire_detection_narrative
      emergency_response_narrative
      infrared_inspection_narrative
      external_fire_exposure_narrative

      buildings {
        name
        roof
        number_of_stories_high
        height
        number_of_basement_levels
        total_floor_area
        number_of_fire_areas
        construction_year
        last_addition_year
      }
    }
  }
`;
export const getLossEstimate = /* GraphQL */ `
  query GetLossEstimate($id: ID!) {
    getLossEstimate(id: $id) {
      id
      company_profile {
        id
        name
      }
      location {
        id
        name
      }
      survey {
        id
        name
      }
      pd_bld
      pb_me
      pd_st
      bi_12
      apl_pd
      apl_bi
      mfl_pd
      mfl_bi
      pml_pd
      pml_bi
      total_pml
      total_apl
      total_mfl
      total_pd_bi
      other_loss
      eml_pd
      eml_bi
      total_eml
      nle_pd
      nle_bi
      total_nle
      narrative
      eml_narrative
      nle_narrative
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts($q: StandardQuery) {
    listContacts(q: $q) {
      list {
        id
        name
        job_title
        email
        phone
        locations {
          id
          name
        }
      }
      size
      count
      offset
    }
  }
`;
export const listSics = /* GraphQL */ `
  query ListSics($q: StandardQuery) {
    listSics(q: $q) {
      list {
        code
        industry
        division
        major_group
        industry_group
      }
      size
      count
      offset
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts($q: StandardQuery) {
    listAccounts(q: $q) {
      list {
        id
        name
        created
        updated
        deleted
        is_active
        services
        user_pool_id
        account_ref
        identity_pool_id
        cognito_client_id
        roles {
          id
          name
          role_arn
          role_id
          is_system_role
          created
          updated
          deleted
        }
        companies {
          id
          name
          sic
          logo_image
          sites_count
          surveys_count
          open_recs_count
          total_recs_count
          risk_score
          policy_renewal_date
          last_survey_date
          summary
          created
          updated
          deleted
          is_active
          tiv
          account_ref
        }
      }
      size
      count
      offset
    }
  }
`;
export const listActivityFeeds = /* GraphQL */ `
  query ListActivityFeeds($q: StandardQuery) {
    listActivityFeeds(q: $q) {
      list {
        id
        activity
        entity {
          id
          name
          type
          deleted
        }
        platformuser {
          name
          id
          deleted
        }
        company_profile {
          id
          name
          deleted
        }
        location {
          id
          name
          deleted
        }
        target {
          id
          name
          type
          deleted
        }
        value
        created
      }
      size
      count
      offset
    }
  }
`;
export const searchEsResults = /* GraphQL */ `
  query SearchEsResults($q: SearchQuery) {
    searchESResults(q: $q) {
      list {
        id
        record_type
        title
        description
        media_type
        document_type
        file_name
        file_type
        preview_image
        company_profile
        company_profile_name
        location
        location_name
        survey
        survey_name
        agency
        created_by
        date
        highlight
      }
      facets {
        key
        count
      }
      size
      count
      offset
    }
  }
`;
export const getNewRecommendationIDforLocation = /* GraphQL */ `
  query GetNewRecommendationIDforLocation($location: ID!) {
    getNewRecommendationIDforLocation(location: $location)
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages($q: StandardQuery) {
    listMessages(q: $q) {
      list {
        id
        sender {
          id
          name
          avatar_image
        }
        created
        subject
        body
        rec_status_from
        rec_status_to
      }
      size
      count
      offset
    }
  }
`;
export const listInsuranceProductsAndAccount = /* GraphQL */ `
  query ListInsuranceProducts($id: ID!, $q: StandardQuery) {
    listInsuranceProducts(q: $q) {
      count
      size
      count
      offset
      list {
        id
        name
        description
        sectors {
          id
        }
        avg_risk_score
        avg_risk_score_change
        num_completed_activities
        num_expected_activities
        num_clients
        insurance_product_account_status
      }
    }
    getPlatformUser(id: $id) {
      account {
        avg_risk_score
        avg_risk_score_change
      }
    }
  }
`;
export const listInsuranceProductsForDropDown = /* GraphQL */ `
  query ListInsuranceProducts($q: StandardQuery) {
    listInsuranceProducts(q: $q) {
      count
      size
      count
      offset
      list {
        id
        name
      }
    }
  }
`;
export const getAccountAndInsuranceProducts = /* GraphQL */ `
  query ListAccountsQuery($q: StandardQuery) {
    listInsuranceProducts(q: $q) {
      count
      size
      count
      offset
      list {
        id
        name
        description
        sectors {
          id
        }
        avg_risk_score
        avg_risk_score_change
        num_completed_activities
        num_expected_activities
        num_clients
      }
    }
  }
`;
export const getAccountforDashboard = /* GraphQL */ `
  query GetAccount($id: ID!, $q: StandardQuery) {
    getAccount(id: $id) {
      avg_risk_score
      avg_risk_score_change
    }
  }
`;
export const getInsuranceProduct = /* GraphQL */ `
  query GetInsuranceProduct($id: ID!) {
    getInsuranceProduct(id: $id) {
      id
      name
      code
      description
      updated
      num_completed_activities
      num_expected_activities
      avg_risk_score_change
      avg_risk_score
      num_clients
      insurance_product_account_status
      accounts {
        id
        name
      }
      risk_model {
        id
        sector {
          name
          id
        }
      }
      risk_models {
        id
        sector {
          id
          name
        }
      }
      clients {
        account_ref
        id
        name
        sic
        sector {
          id
          name
        }
        address {
          id
          city
          state_province
          country_code
          country
        }
        my_sme_spec_account {
          id
          name
        }
        logo_image
        risk_score
        first_risk_score
      }
    }
  }
`;
export const getInsurance = /* GraphQL */ `
  query GetPlatformUser($id: ID!, $q: StandardQuery) {
    # query GetPlatformUser($id: ID!) {
    getPlatformUser(id: $id) {
      account {
        avg_risk_score
        avg_risk_score_change
        insurance_products(q: $q) {
          id
          name
          description
          num_completed_activities
          num_expected_activities
          avg_risk_score_change
          avg_risk_score
          num_clients
        }
        # companies {
        #     id
        #     name
        #     insurance_product {
        #       id
        #       name
        #       description
        #       num_completed_activities
        #       num_expected_activities
        #       avg_risk_score_change
        #       avg_risk_score
        #       num_clients
        #     }
        # }
      }
    }
  }
`;
export const listLocationsForActivities = /* GraphQL */ `
  query ListActivities($q: ListActivitiesQuery) {
    listActivitys(q: $q) {
      offset
      size
      count
      list {
        id
        location {
          id
          name
          timezone
        }
      }
    }
  }
`;
export const listActivitiesForSchedules = /* GraphQL */ `
  query ListActivities($q: ListActivitiesQuery) {
    listActivitys(q: $q) {
      offset
      size
      count
      available
      done
      done_month
      missed
      missed_month
      overdue
      total
      total_month
      pending_approval
      list {
        activity_source
        id
        started
        complete_by
        available_after
        late_until
        calculated_status
        submitted
        requires_approval
        submitted_by {
          id
          last_login
          is_active
          avatar_image
          name
          email
          phone_number
        }
        assignee {
          id
          last_login
          is_active
          avatar_image
          name
          email
          phone_number
        }
        master_activity_template {
          id
          name
          is_policy_condition
        }
        assignee {
          id
          last_login
          is_active
          avatar_image
          name
          email
          phone_number
          account {
            id
          }
        }
        location {
          id
          name
          timezone
        }
        company_profile {
          id
          name
          my_sme_spec_account {
            id
            name
          }
        }
      }
    }
  }
`;
export const listActivities = /* GraphQL */ `
  query ListActivities($q: ListActivitiesQuery) {
    listActivitys(q: $q) {
      offset
      size
      count
      list {
        id
        master_activity_template {
          id
          name
        }
        complete_by
        available_after
        late_until
        calculated_status
        status
        submitted
        started
        assignee {
          id
          last_login
          is_active
          avatar_image
          name
          email
          phone_number
        }
        location {
          id
          geo
          name
        }
      }
    }
  }
`;
export const getActivityTemplate = /* GraphQL */ `
  query GetActivityTemplate($id: ID!) {
    getActivityTemplate(id: $id) {
      id
      name
      description
      activity_type
      assignment_type
      image
      overview
      est_comp_time
      available_for
    }
  }
`;
export const getActivity = /* GraphQL */ `
  query GetActivity($id: ID!) {
    getActivity(id: $id) {
      activity_type
      available_after
      complete_by
      created
      deleted
      engagement_time
      id
      last_postponed_at
      late_until
      calculated_status
      meta
      schedule_grouping
      started
      status
      submitted
      updated
      engagement_time
      requires_approval
      datapoints {
        activity
        created
        data {
          value {
            key
            text
            status
          }
          meta
        }
        deleted
        geo
        geo_accuracy
        id
        platformuser
        step
        updated
      }
      assignee {
        id
        last_login
        created
        updated
        is_active
        name
        avatar_image
      }
      master_activity_template {
        is_policy_condition
        id
        name
        image
        overview
        description
        rec_frequency_interval
        rec_frequency_unit
        checklist
        est_comp_time
        available_for
        late_after
        assignment_type
        effort
        end_time
        start_time
        owner_account {
          id
          name
        }
        master_risk_category {
          name
          id
        }
      }
      company_profile {
        id
        name
        my_sme_spec_account {
          id
          name
        }
      }
      location {
        id
        name
        timezone
      }
      submitted_by {
        id
        last_login
        created
        updated
        is_active
        name
        avatar_image
      }
      submitted_version {
        id
        checklist
      }
    }
  }
`;
export const listLocationsForAssignments = /* GraphQL */ `
  query ListLocations($q: StandardQueryWithCompany) {
    listLocations(q: $q) {
      offset
      size
      count
      list {
        id
        name
        geo
        location_type
        timezone
        parent {
          id
          name
          location_type
        }
      }
    }
  }
`;
export const listRiskModels = /* GraphQL */ `
  query ListRiskModels($q: StandardQuery) {
    listRiskModels(q: $q) {
      offset
      size
      count
      list {
        id
        is_master
        updated
        num_clients
        masterRiskParameters {
          id
          # impact
          name
          risk_categories {
            id
            name
          }
          description
        }
        sector {
          id
          name
        }
        # insuranceProduct {
        #   id
        #   name
        #   num_clients
        # }

        product_version {
          version
          product {
            name
          }
        }
        parent {
          id
          is_master
        }
        default_mrmp {
          title
          id
        }

        risk_categories {
          id
          name
          description

          risk_parameters {
            id
            impact
            default_impact
            name
            description
            risk_categories {
              id
              name
            }
            risk_controls {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export const getRiskModel = /* GraphQL */ `
  query GetRiskModel($id: ID!) {
    getRiskModel(id: $id) {
      id
      is_master
      updated
      num_clients
      masterRiskParameters {
        id
        # impact
        name
        risk_categories {
          id
          name
        }
        description
        risk_controls {
          id
          name
          description
          states {
            id
            state
            description
          }
        }
      }
      sector {
        id
        name
      }
      # insuranceProduct {
      #   id
      #   name
      #   num_clients
      # }
      parent {
        id
        is_master
      }
      default_mrmp {
        title
        id
      }
    }
  }
`;
export const listMasterRiskCategorys = /* GraphQL */ `
  query ListMasterRiskCategorys($q: StandardQueryWithCompanyOptional) {
    listMasterRiskCategorys(q: $q) {
      list {
        id
        description
        name
        risk_parameters {
          id
          name
          description
          # impact
          risk_categories {
            id
            name
          }
          risk_controls {
            id
            name
            description
            states {
              id
              state
              description
            }
          }
        }
      }
      offset
      size
      count
    }
  }
`;
export const listMasterRiskControls = /* GraphQL */ `
  query ListMasterRiskControls($q: StandardQuery) {
    listMasterRiskControls(q: $q) {
      list {
        risk_parameters {
          id
          name
          risk_categories {
            id
            name
          }
        }
        description
        id
        name
        states {
          id
          state
          description
        }
      }
      offset
      size
      count
    }
  }
`;
export const getMasterRiskParameter = /* GraphQL */ `
  query getMasterRiskParameter($id: ID!) {
    getMasterRiskParameter(id: $id) {
      description
      id
      impact
      name
      risk_categories {
        id
        name
      }
      risk_controls {
        id
        name
        description
        risk_parameters {
          id
        }
        states {
          id
          state
          description
          current_version
        }
      }
    }
  }
`;
export const listMasterRiskParameters = /* GraphQL */ `
  query ListMasterRiskParameters($q: StandardQuery) {
    listMasterRiskParameters(q: $q) {
      list {
        description
        id
        impact
        name
        risk_categories {
          id
          name
          sum_controls
          sum_parameters
        }
        risk_controls {
          id
          name
          description
          risk_parameters {
            id
          }
          states {
            id
            state
            description
            current_version
          }
        }
      }
      offset
      size
      count
    }
  }
`;
export const listLocationsForFilter = /* GraphQL */ `
  query ListLocations($q: StandardQueryWithCompany) {
    listLocations(q: $q) {
      count
      list {
        id
        name
      }
    }
  }
`;
export const getMasterRMPAssociations = /* GraphQL */ `
  query GetMasterRiskManagementProgram($id: ID!) {
    getMasterRiskManagementProgram(id: $id) {
      id
      title
      activities_count
      updated
      program_associations {
        company_profile {
          name
          id
          account_ref
        }
        status
        updated
        deleted
      }
    }
  }
`;
export const getMasterActivityTemplate = /* GraphQL */ `
  query GetMasterActivityTemplate($id: ID!) {
    getMasterActivityTemplate(id: $id) {
      id
      name
      image
      overview
      description
      rec_frequency_interval
      rec_frequency_unit
      manual_scheduling
      checklist
      est_comp_time
      available_for
      late_after
      assignment_type
      effort
      end_time
      start_time
      activity_source
      mapped_controls {
        id
        name
        description
        risk_parameters {
          id
        }
        states {
          id
          state
          description
          current_version
        }
      }
      mappings {
        completion_percentage_range
        priority
        id
        step_id
        step_option
        selected
        updated
        master_risk_control {
          description
          id
          name
          states {
            id
            state
            description
          }
        }
        master_risk_control_state {
          id
          state
          description
        }
        master_risk_control {
          risk_parameters {
            risk_categories {
              id
              name
            }
          }
        }
      }
      master_risk_category {
        name
        id
      }
      push_notification_config
    }
  }
`;
export const getMasterRiskManagementProgram = /* GraphQL */ `
  query GetMasterRiskManagementProgram($id: ID!) {
    getMasterRiskManagementProgram(id: $id) {
      id
      title
      updated
      created
      activities_count
      sections {
        id
        title
        description
        activities {
          master_activity_template {
            id
            name
            description
            master_risk_category {
              id
              name
            }
          }
          schedule_after_interval
          schedule_after_unit
          trigger_type
          trigger_id
          step_id
          step_options
          assignment_type
          rec_frequency_interval
          rec_frequency_unit
          priority
          schedule_grouping
          scheduling_days
          scheduling_months
          control_states {
            control {
              id
              name
              states {
                id
                state
              }
            }
            state {
              id
              state
            }
            op
          }
          weather_trigger {
            op
            param
            value
          }
        }
      }
      assigned_risk_models {
        id

        product_version {
          version
          product {
            name
          }
        }
        sector {
          id
          name
        }
      }
    }
  }
`;
export const listActivityTemplates = /* GraphQL */ `
  query ListActivityTemplates($q: StandardQuery) {
    listActivityTemplates(q: $q) {
      size
      offset
      count
      list {
        id
        name
        rec_frequency_interval
        rec_frequency_unit
        description
        master_risk_category {
          id
          name
        }
        risk_managment_program {
          id
          title
        }
      }
    }
  }
`;
export const listActivitySchedules = /* GraphQL */ `
  query ListActivitySchedules($q: ListActivitySchedulesQuery) {
    listActivitySchedules(q: $q) {
      count
      offset
      size
      list {
        schedule_type
        id
        name
        interval
        unit
        is_active
        next_activity_due_date
        deleted
        status
        assignment_type
        num_expected_activities
        num_completed_activities
        comp_percentage
        master_risk_management_program {
          id
          title
        }
        assignees {
          id
          last_login
          is_active
          avatar_image
          name
          email
          phone_number
        }
      }
    }
  }
`;
export const listMasterRiskManagementPrograms = /* GraphQL */ `
  query ListMasterRiskManagementPrograms($q: StandardQuery) {
    listMasterRiskManagementPrograms(q: $q) {
      list {
        id
        title
        updated
        created
        activities_count
      }
      count
      offset
      size
    }
  }
`;
export const listParamStateMappings = /* GraphQL */ `
  query listParamStateMappings($q: StandardQueryWithoutAccount) {
    listParamStateMappings(q: $q) {
      list {
        masterriskparameter
        masterriskcontrol
        mastercontrolstate
        value
      }
      offset
      size
      count
    }
  }
`;
export const getDecileAnalysis = /* GraphQL */ `
  query GetDecileAnalysis($input: DecileAnalysiskInput) {
    getDecileAnalysis(input: $input) {
      data {
        bins {
          max
          mean
          median
          min
          num_clients
          bin
        }
        max
        mean
        median
        min
        num_clients
      }
    }
  }
`;
export const exportPlatformUsers = /* GraphQL */ `
  query ExportPlatformUsers($q: StandardQuery) {
    exportPlatformUsers(q: $q) {
      urls
    }
  }
`;
export const listInsuranceProducts = /* GraphQL */ `
  query ListInsuranceProducts($q: StandardQuery) {
    listInsuranceProducts(q: $q) {
      list {
        id
        name
        description
        updated
        sectors {
          id
        }
        accounts {
          id
          name
        }
        risk_models {
          id
          updated
          sector {
            id
            name
          }
          parent {
            id
            version
          }
          default_mrmp {
            title
            id
          }
        }
        risk_model {
          id
          updated
          sector {
            id
            name
          }
          parent {
            id
            version
          }
          default_mrmp {
            title
            id
          }
          # insuranceProduct {
          #   id
          #   name
          #   num_clients
          # }

          product_version {
            version
            product {
              name
            }
          }
        }
      }
      offset
      size
      count
    }
  }
`;
export const getLocationActivityCount = /* GraphQL */ `
  query GetLocation($id: ID!) {
    getLocation(id: $id) {
      id
      activities_counters {
        available
        done
        done_month
        missed
        missed_month
        overdue
        total
        total_month
      }
    }
  }
`;
export const getClientActivityCount = /* GraphQL */ `
  query GetCompanyProfile($id: ID!) {
    getCompanyProfile(id: $id) {
      id
      activities_counters {
        available
        done
        done_month
        missed
        missed_month
        overdue
        total
        total_month
      }
    }
  }
`;
export const getIssue = /* GraphQL */ `
  query GetIssue($id: ID!) {
    getIssue(id: $id) {
      action
      activity {
        master_activity_template {
          id
          name
        }
      }
      assignee {
        id
        name
        avatar_image
        account {
          id
        }
        last_login
        is_active
      }
      cause
      closed
      created
      deleted
      description
      id
      is_claim
      location {
        id
        name
      }
      priority
      ref
      reporter {
        id
        name
        avatar_image
        last_login
        is_active
      }
      attachments {
        preview_image
        id
      }
      status
      title
      type
      updated
    }
  }
`;
export const listIssues = /* GraphQL */ `
  query ListIssues($q: ListIssuesQuery) {
    listIssues(q: $q) {
      list {
        action
        activity {
          id
          master_activity_template {
            id
            name
          }
        }
        company_profile {
          id
          name
          insurer {
            id
          }
          my_sme_spec_account {
            id
            name
          }
          # insurer: IAccount | null;
          # my_sme_account: IAccount | null;
          # my_sme_spec_account: IAccount | null;
        }
        assignee {
          id
          name
          avatar_image
          last_login
          is_active
          account {
            id
          }
        }
        reporter {
          id
          name
          avatar_image
          last_login
          is_active
        }
        cause
        closed
        created
        deleted
        description
        id
        is_claim
        location {
          id
          name
        }
        priority
        ref
        reporter {
          id
          name
        }
        status
        title
        type
        updated
      }
      size
      count
      offset
    }
  }
`;
export const listFnolTemplates = /* GraphQL */ `
  query ListFnolTemplates($q: StandardQuery) {
    listFnolTemplates(q: $q) {
      list {
        id
        name
        updated
        tpa {
          id
          name
        }
      }
      size
      count
      offset
    }
  }
`;
/* tslint:disable */
/* eslint-disable */
